import { __serializeForClipboard } from 'prosemirror-view';
if (!__serializeForClipboard)
    throw new Error('__serializeForClipboard not exported from prosemirror-view module.');
export { __serializeForClipboard as serializeForClipboard };
